@if (view$ | async; as view) {
  <div class="category-label bold padding-left">Help Category: {{help.category}}</div>
  <h3 class="h4 bold">{{help.name}}</h3>
  <div class="container" [innerHtml]="view"></div>
} @else {
  <div class="loader-container">
    <static-loader></static-loader>
  </div>
}
